function s(){const{$wrapperEl:s,params:e,slides:l}=this;s.children(`.${e.slideClass}.${e.slideDuplicateClass},.${e.slideClass}.${e.slideBlankClass}`).remove(),l.removeAttr("data-swiper-slide-index")}export{s as default};
//# sourceMappingURL=loopDestroy.js.map
